<template>
    <ModalComponent
        :name="'editar-precio-' + precio.id"
        title="Editar precio"
        @close="cerrar()"
    >
        <Form :data="precio" @terminado="editPrice()"/>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/backend/components/ModalComponent.vue';
import Form from '../Form.vue';

export default {
    props: ['pack_id', 'precio'],
    methods: {
        editPrice() {
            this.precio.pack_id = this.pack_id;
            this.precio.precio_id = this.precio.id;

            this.$store.dispatch(this.config.getVuexAlias('back.teatro.packs-events.show.prices.edit'), this.precio).then(res => {
                this.$emit('actualizar');
                this.cerrar();
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.editPrice();
            }
        },
        cerrar() {
            this.$modal.hide('editar-precio-' + this.precio.id);
        }
    },
    components: {
        ModalComponent, Form
    }
}
</script>
